<button mat-icon-button class="close-button" [mat-dialog-close]="true">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>
<h1 mat-dialog-title>Contact</h1>
<div mat-dialog-content>
  <div class="contact-page">
    <div class="sub-container">

      <mat-card appearance="outlined">
        <div class="fx-row xs-fx-col fx-main-between fx-cross-start">
          <div  class="left-info-panel xs-fx-flex-35-in-col sm-fx-flex-45 print-fx-flex-35 gt-sm-fx-flex-35">

            <div class="c-info">
              <div class="enroll_img">
                <div class="avtar">
                  <img style="height:100px;width:100px;" class=""
                    [src]="userService.ImageUrl" alt="companylogo"
                    [default]="'assets/images/user.png'">
                  </div>

                </div>
                <h3 [textContent]="userService.FirstName + ' ' + userService.LastName" class="color-f-s-23">tori belle cosmetics LLC</h3>
                <div class="content">
                  <ul class="social list-inline text-center fx-row fx-main-evenly fx-cross-center">
                    <mat-toolbar class="social list-inline text-center fx-row fx-main-evenly fx-cross-center"
                      >

                    @if (userService.Facebook) {
                      <li><a [href]="userService.Facebook"><i class="fa fa-facebook-f"></i></a></li>
                    }
                    @if (userService.Linkdin) {
                      <li><a [href]="userService.Linkdin"><i class="fa fa-linkedin"></i></a></li>
                    }
                    @if (userService.Instagram) {
                      <li ><a [href]="userService.Instagram"><i class="fa fa-instagram"></i></a></li>
                    }
                    @if (userService.Twitter) {
                      <li><a [href]="userService.Twitter"><i class="fa fa-twitter"></i></a></li>
                    }

                  </mat-toolbar>
                </ul>
                <h6 class="color-f-s-24" [textContent]="userService.SecondaryPhone || userService.PrimaryPhone"></h6>
                <a href="mailto:{{userService.EmailAddress}}" class="mailaddress" [textContent]="userService.EmailAddress"></a>
                <p class="ds_AboutMe" [textContent]="userService.AboutMe"></p>
              </div>
            </div>
          </div>
          <div   class="contact-form xs-fx-flex-60-in-col sm-fx-flex-50 print-fx-flex-60 gt-sm-fx-flex-60">
            <div class="title">
              <h3 translate="contact_" class="color-f-s-19"></h3>
            </div>
            <form class="fx-row-wrap">
              <div [appBreakpointClass]="{'sm':'mt-1','xs':'mt-1'}" class="px-1 fx-flex-100">
                <mat-form-field class="w-100 ds-validate">
                  <mat-label translate="user_first_name"></mat-label>
                  <input matInput [(ngModel)]="contact.FirstName" [ngModelOptions]="{standalone: true}" name="FirstName"
                    validate noempty="true">
                </mat-form-field>
              </div>
              <div [appBreakpointClass]="{'sm':'mt-1','xs':'mt-1'}" class="px-1 fx-flex-100">
                <mat-form-field class="w-100 ds-validate">
                  <mat-label translate="user_last_"></mat-label>
                  <input matInput [(ngModel)]="contact.LastName" [ngModelOptions]="{standalone: true}" name="LastName"
                    validate noempty="true">
                </mat-form-field>
              </div>
              <div [appBreakpointClass]="{'sm':'mt-1','xs':'mt-1'}" class="px-1 fx-flex-100">
                <mat-form-field class="w-100 ds-validate">
                  <mat-label translate="MobilePhone_"></mat-label>
                  <input matInput [(ngModel)]="contact.MobilePhone" [ngModelOptions]="{standalone: true}" name="Phone"
                    phoneno="true" inputspace="true" validate noempty="true" maxlength="20" inputonlynumber="true">
                </mat-form-field>
              </div>
              <div [appBreakpointClass]="{'sm':'mt-1','xs':'mt-1'}" class="px-1 fx-flex-100">
                <mat-form-field class="w-100 ds-validate">
                  <mat-label translate="email_"></mat-label>
                  <input matInput [(ngModel)]="contact.Email" [ngModelOptions]="{standalone: true}" name="email"
                    validate noempty="true" email="true">
                </mat-form-field>
              </div>
              <div [appBreakpointClass]="{'sm':'mt-1','xs':'mt-1'}" class="px-1 fx-flex-100">
                <mat-form-field class="w-100 ds-validate">
                  <mat-label translate="message_"></mat-label>
                  <textarea matInput rows="6" [(ngModel)]="contact.Message" [ngModelOptions]="{standalone: true}"
                  name="content"></textarea>
                </mat-form-field>
              </div>
              <div [appBreakpointClass]="{'sm':'mt-1','xs':'mt-1'}" class="px-1 fx-flex-100">
                <mat-form-field class="w-100 ds-validate fx-row-in-form-field">
                  <div class="fx-col fx-flex-100">
                    <div class="fx-row fx-main-between fx-cross-stretch fx-flex-100-in-col">
                      <div class="captcha_code fx-flex-56 xs-fx-flex-63" id="captcha_code">
                        <span translate>captcha_</span><span id="captchaQuestion"></span><span> = </span>
                      </div>
                      <div class="captcha_answer m-r-10 fx-flex-39 xs-fx-flex-30">
                        <input matInput id="answer" inputonlynumber="true" validate noempty="true"
                          [(ngModel)]="contact.result" (focusout)="checkCaptch()" [ngModelOptions]="{standalone: true}" name="answer" type="text" >
                      </div>
                    </div>
                    @if (!captchaError) {
                      <div class="captchaError">
                        <small class="has-error help-block" translate>enter_valid_captcha</small>
                      </div>
                    }
                    <div class="reload_captcha">
                      <span translate>reload_captcha</span><span><img src="/assets/images/arrow.png"
                    [default]="'assets/images/noimage.png'" (click)="getRandom(true)"></span>
                  </div>
                </div>
              </mat-form-field>
            </div>
            <div class="button-wrap" [appBreakpointClass]="{'sm':'mt-1','xs':'mt-1'}" class="px-1 fx-flex-100">
              <button class="btn-project" mat-raised-button color="primary" validate trigger-check="true"
              (success)="contactUser()">{{'_submit'| translate}}</button>
            </div>
          </form>
        </div>
      </div>

    </mat-card>
  </div>
</div>
</div>